import React, { useContext } from 'react';

import { useDynamicModalsInternal, DynamicModalContext } from './useDynamicModals';

import noop from 'lodash/noop';

/**
 * Dynamic Modals are powered by 2 components, a ModalLink and NestedModals.
 *
 * ModalLink is responsible for adding the modals into the DynamicModal context
 * these come from content (contentful).
 *
 * NestedModals is responsible for rendering the Routes that actually render
 * the modals in a Switch.
 * - There should only be 1 NestedModals component per page.
 * - NestedModals should clear the context when it is unmounted.
 *
 */
const DynamicModal = React.createContext<DynamicModalContext>({
  modals: [],
  clear: noop,
  add: noop,
});
DynamicModal.displayName = 'DynamicModal';

export const useDynamicModals = () => useContext(DynamicModal);

export const DynamicModalProvider: React.FC = ({ children }) => (
  <DynamicModal.Provider value={useDynamicModalsInternal()}>{children}</DynamicModal.Provider>
);

export const DynamicModalConsumer = DynamicModal.Consumer;
